import { PhoneCall } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

// Étape cible de chaque issue d'appel, par pipeline : proposée d'après les noms d'étapes, inactive tant qu'elle n'est pas cochée
export function CallOutcomesSection({ pipelines }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/settings/call-outcomes").then(({ data: d }) => setData(d)).catch(() => setData(false)); }, []);
  if (!data) return null;
  const update = async (name, key, patch) => {
    const next = { ...data.pipelines, [name]: { ...data.pipelines[name], [key]: { ...data.pipelines[name][key], ...patch } } };
    setData({ ...data, pipelines: next });
    try { setData((await api.put("/settings/call-outcomes", { pipelines: next })).data); toast.success("Règle d'issue d'appel enregistrée."); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur, réessayez."); }
  };
  return (
    <section className="settings-section" data-testid="call-outcomes-section">
      <div className="section-title"><PhoneCall size={20} /><div><p className="eyebrow">ISSUES D'APPEL</p><h2>Étape cible par issue</h2></div></div>
      <p className="fileprep-dedup-hint">Relances automatiques : NRP → demain à l'autre demi-journée, Messagerie → J+2, À rappeler → date et heure choisies, RDV/Qualifié → demain, Pas intéressé → Perdu (motif « Pas intéressé »). Une étape proposée ne s'applique que si vous cochez « Active ».</p>
      <ol className="pls-list">
        {pipelines.map((p, i) => {
          const rules = data.pipelines[p.name] || {};
          const active = Object.values(rules).filter((r) => r.active).length;
          return (
            <li key={p.name} data-testid={`call-outcome-row-${i}`}>
              <div className="pls-row"><button type="button" className="pls-name" onClick={() => setOpen(open === p.name ? null : p.name)} data-testid={`call-outcome-open-${i}`}>{p.name} <small>{active ? `${active} règle(s) active(s)` : "aucune règle active"}</small></button></div>
              {open === p.name && (
                <div className="co-grid">
                  {Object.entries(data.outcomes).map(([key, label]) => (
                    <label key={key} className="co-rule">{label}
                      <select className="pl-select" value={rules[key]?.step_id || ""} onChange={(e) => update(p.name, key, { step_id: Number(e.target.value) || null })} data-testid={`call-outcome-step-${i}-${key}`}>
                        <option value="">Ne pas changer l'étape</option>
                        {p.steps.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
                      </select>
                      <span className="co-active"><input type="checkbox" checked={Boolean(rules[key]?.active)} disabled={!rules[key]?.step_id} onChange={(e) => update(p.name, key, { active: e.target.checked })} data-testid={`call-outcome-active-${i}-${key}`} /> Active</span>
                    </label>
                  ))}
                </div>
              )}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
